
import { useEffect, useState } from "react";
import { QueryDefinition } from "@/components/admin/dashboard/queries";
import { executeWidgetQuery, getAvailableQueries } from "@/components/admin/dashboard/queries";
import { DashboardType } from "@/components/admin/dashboard/widget-types";
import { WidgetQueryResult } from "./types";

export function useWidgetQueries() {
  const [availableQueries, setAvailableQueries] = useState<QueryDefinition[]>([]);

  // Fetch available database queries
  useEffect(() => {
    const queries = getAvailableQueries();
    setAvailableQueries(queries);
  }, []);

  // Get available database queries filtered by dashboard type
  const getAvailableDatabaseQueries = (dashboardType?: DashboardType) => {
    return dashboardType 
      ? availableQueries.filter(q => 
          q.dashboardTypes.includes(dashboardType) || 
          q.dashboardTypes.includes('both' as DashboardType)
        )
      : availableQueries;
  };

  // Test a query by name
  const testQuery = async (queryName: string): Promise<WidgetQueryResult> => {
    try {
      return await executeWidgetQuery(queryName);
    } catch (error) {
      return { data: null, error };
    }
  };

  return {
    availableQueries,
    getAvailableDatabaseQueries,
    testQuery
  };
}
